/* global THREE */

import aframe from "aframe";
import { bindEvent, bindEventPlayPause } from "aframe-event-decorators";

const debug = false;

// const utils = aframe.utils;

let poolEl;

aframe.registerComponent("smart-missile", {
  schema: {
    speed: { type: "number", default: 1.0 },
    steerSpeed: { type: "number", default: Math.PI },
    avoidDistance: { type: "number", default: 0.2 },
    timeWarpFactor: { type: 'number', default: 1 }
  },
  init: function () {
    if (poolEl === undefined) {
      poolEl = document.querySelector("[mipool__explosion]");
    }
    this.system = this.el.sceneEl.systems.missile;
  },
  reset: function () {
    this.target = undefined;
    this._timeWarpFactor = this.data.timeWarpFactor;
    this.el.emit("smartmissilespawned", this, true);
    this.el.components.misound.playSound();
  },
  tick: (() => {
    const v1 = new THREE.Vector3();

    return function (t, dt) {
      this._steer(dt);

      const forwards = v1
        .set(0, 0, -1)
        .applyQuaternion(this.el.object3D.quaternion);
      this.el.object3D.position.addScaledVector(
        forwards,
        this.data.speed * dt / 1000 * this._timeWarpFactor
      );

      if (
        (this.target &&
          this.el.object3D.position.distanceTo(this.target.object3D.position) <
          0.0025) ||
        this.el.object3D.position.y < -0.02
      ) {
        this._explode();
      }
    };
  })(),
  collisionstart: bindEvent(function () {
    this.el.emit("smartmissiledestroyed", this, true);
    this._explode();
  }),
  _explode: function () {
    const explosion = poolEl.components.mipool__explosion.requestEntity();
    if (explosion !== undefined) {
      explosion.setAttribute("position", this.el.object3D.position);
      explosion.setAttribute("explosion", {
        color: this.data.color,
        growTime: 1.0,
        fadeTime: 1.0,
        size: 1
      });
      explosion.components.explosion.reset();
      explosion.play();
    }

    this.el.components.misound.stopSound();

    this.el.emit("smartmissileremoved", this, true);
    this.system.release(this.el);
  },
  _steer: (() => {
    const v1 = new THREE.Vector3();
    const v2 = new THREE.Vector3();
    // const q1 = new THREE.Quaternion();
    const q2 = new THREE.Quaternion();

    return function (dt) {
      if (!this.target || !this.target.object3D.visible) {
        this._selectTarget();
        if (!this.target) return; // still no target
      }

      const targetDirection = v1
        .copy(this.target.object3D.position)
        .sub(this.el.object3D.position)
        .normalize();

      const targetWithAvoidance = this._avoidExplosions(targetDirection);

      this._rotateTowards(
        targetWithAvoidance,
        this.data.steerSpeed * dt / 1000
      );

      if (debug) {
        const localDirection = v2
          .copy(targetWithAvoidance)
          .applyQuaternion(q2.copy(this.el.object3D.quaternion).inverse());
        this.el.setAttribute("meshline", { end: localDirection });
      }
    };
  })(),
  _avoidExplosions: (() => {
    const v1 = new THREE.Vector3();
    const v2 = new THREE.Vector3();

    return function (direction) {
      const colliders = this.el.sceneEl.systems.collider.colliders;
      const avoidance = v2.set(0, 0, 0);
      for (const c of colliders) {
        if (!c.isPlaying || !c.components.explosion) {
          continue;
        }

        const radius = c.components.collider.data.radius * c.object3D.scale.x;
        const distance =
          this.el.object3D.position.distanceTo(c.object3D.position) - radius;

        if (distance > this.data.avoidDistance) {
          continue;
        }

        const avoidWeight = 1 - distance / this.data.avoidDistance;
        const avoidWeightSqrd = avoidWeight * avoidWeight * avoidWeight;

        const normal = v1
          .copy(this.el.object3D.position)
          .sub(c.object3D.position)
          .normalize();
        avoidance.addScaledVector(normal, avoidWeightSqrd);
      }

      direction.addScaledVector(avoidance.normalize(), 1);

      return direction.normalize();
    };
  })(),
  _selectTarget() {
    this.target = document
      .querySelector("[game-state]")
      .components["game-state"].nearestLiveSiloOrCityToPoint(
        this.el.object3D.position
      );
  },
  _rotateTowards: (() => {
    const v1 = new THREE.Vector3();
    const q1 = new THREE.Quaternion();

    return function (direction, maxAngle) {
      const forwards = v1
        .set(0, 0, -1)
        .applyQuaternion(this.el.object3D.quaternion)
        .normalize();
      const angle = forwards.angleTo(direction);
      if (angle <= Number.EPSILON) {
        return;
      }
      const rotation = q1
        .setFromUnitVectors(forwards, direction)
        .multiply(this.el.object3D.quaternion);
      const t = Math.min(maxAngle / angle, 1);
      this.el.object3D.quaternion.slerp(rotation, t);
    };
  })(),
  gamestatechanged: bindEventPlayPause({ target: "[game-state]" }, function (
    evt
  ) {
    const newState = evt.detail;
    if (newState !== "Playing") {
      this.system.release(this.el);
    }
  }),
  startTimeWarp: bindEvent({ target: '[game-state]' }, function (evt) {
    this._timeWarpFactor = evt.detail.factor;
  }),
  endTimeWarp: bindEvent({ target: '[game-state]' }, function (evt) {
    this._timeWarpFactor = 1;
  })
});
